import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCombobox, {
    attrs: {
      "disabled": _vm.disabled,
      "label": _vm.label || _vm.$i18n_t('Common.tags'),
      "items": _vm.tagItems,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "height": _vm.height,
      "multiple": "",
      "hide-details": "",
      "search-input": _vm.search,
      "return-object": !_vm.externalTags.length,
      "data-cy": _vm.dataCy
    },
    on: {
      "keydown": _vm.restrictCharacters,
      "update:searchInput": function ($event) {
        _vm.search = $event;
      },
      "update:search-input": function ($event) {
        _vm.search = $event;
      },
      "change": _vm.process
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function ({
        attrs,
        item
      }) {
        return [_c(VChip, _vm._b({
          attrs: {
            "small": "",
            "data-cy": `tag_${item}`,
            "close": !_vm.externalTags.includes(item),
            "disabled": _vm.disabled || _vm.externalTags.includes(item)
          },
          on: {
            "click:close": function ($event) {
              return _vm.remove(item);
            }
          }
        }, 'v-chip', attrs, false), [_vm._v("\n      " + _vm._s(item) + "\n      "), _vm.externalTags.includes(item) ? [_c(VIcon, {
          staticClass: "ml-1",
          attrs: {
            "size": "small"
          }
        }, [_vm._v("fa-sitemap")])] : _vm._e()], 2)];
      }
    }]),
    model: {
      value: _vm.internalTags,
      callback: function ($$v) {
        _vm.internalTags = $$v;
      },
      expression: "internalTags"
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };